"use client";

import { emitUsageEvent } from "../lib/umami";
import { ChevronDown, Copy } from "lucide-react";
import { useState } from "react";
import styles from "./DocumentActions.module.css";
import { correctionUrl } from "../lib/corrections";

export default function DocumentActions({
  markdown,
  url,
}: {
  markdown: string;
  url: string;
}) {
  const [status, setStatus] = useState("");
  const prompt = encodeURIComponent("Read from " + url + " so I can ask questions about it.");

  async function copyPage() {
    try {
      await navigator.clipboard.writeText(markdown);
      emitUsageEvent("page_copy");
      setStatus("Copied");
    } catch {
      setStatus("Clipboard unavailable");
    }
  }

  return (
    <div className={styles.actions} data-pagefind-ignore="all">
      <button className={styles.copy} onClick={copyPage} type="button">
        <Copy aria-hidden="true" size={16} />
        {status === "Copied" ? "Copied" : "Copy page"}
      </button>
      <a className={styles.copy} href={correctionUrl(url)} target="_blank" rel="noopener noreferrer" data-docs-event="correction_open">Report an error</a>
      <details className={styles.more}>
        <summary aria-label="More page actions" title="More page actions">
          <ChevronDown aria-hidden="true" size={14} />
        </summary>
        <div className={styles.menu}>
          <button onClick={copyPage} type="button">Copy page as Markdown</button>
          <a href={"https://chatgpt.com/?hints=search&prompt=" + prompt} rel="noopener noreferrer" target="_blank">Open in ChatGPT</a>
          <a href={"https://claude.ai/new?q=" + prompt} rel="noopener noreferrer" target="_blank">Open in Claude</a>
        </div>
      </details>
      <span aria-live="polite" className={styles.status} role="status">{status}</span>
    </div>
  );
}
